import React, { Component } from "react";
import "../Styles/SvgCommand.css";

const BoldIcon = (props) => {
  return (
/*    <svg
      className= {props.selected ? "svgEditorSelected": "svgEditor"}
      height="13"
      viewBox="0 0 55 55"
      width="13"
      style={ { paddingTop:"3px", paddingLeft:"3px", pointerEvents :"none" } }
      
    >
     <g>
       <path d="M10.254,0.035h12.237c4.986,0,8.616,0.967,10.893,2.903c2.273,1.936,3.411,5.015,3.411,9.235   c0,2.778-0.601,5.103-1.804,6.973c-1.204,1.87-2.844,3.001-4.922,3.394v0.329c2.712,0.679,4.67,1.948,5.872,3.806   c1.203,1.86,1.805,4.33,1.805,7.415c0,4.352-1.164,7.759-3.494,10.219C31.923,46.77,28.735,48,24.689,48H10.254V0.035z    M18.652,19.326h4.101c1.881,0,3.204-0.503,3.971-1.508c0.765-1.006,1.147-2.504,1.147-4.496c0-1.99-0.438-3.417-1.312-4.282   c-0.875-0.863-2.254-1.295-4.135-1.295h-3.772V19.326z M18.652,26.772v13.42h4.495c1.858,0,3.242-0.569,4.149-1.707   c0.908-1.138,1.362-2.898,1.362-5.282c0-4.286-1.881-6.431-5.644-6.431H18.652z"/>
      </g>
    </svg>
*/
<svg version="1.0" xmlns="http://www.w3.org/2000/svg" className= {props.selected ? "svgEditorSelected": "svgEditor"}
width="8.000000pt" height="8.000000pt" viewBox="0 0 512.000000 512.000000"
preserveAspectRatio="xMidYMid meet">
 
<g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
 stroke="none">
<path d="M590 2560 l0 -2560 1323 0 c1363 0 1421 2 1582 41 535 132 929 574
1015 1139 16 108 14 331 -5 438 -74 426 -324 779 -695 981 l-70 38 62 49 c242
188 424 448 503 719 33 112 44 299 26 437 -83 625 -508 1098 -1111 1237 -166
39 -246 41 -1455 41 l-1175 0 0 -2560z m2350 1626 c184 -59 322 -200 376 -381
27 -92 24 -231 -8 -321 -64 -182 -224 -325 -406 -363 -35 -7 -251 -11 -632
-11 l-580 0 0 543 c0 299 3 547 7 551 4 4 273 6 598 4 532 -4 595 -6 645 -22z
m159 -2191 c289 -68 473 -366 406 -654 -47 -196 -191 -347 -390 -408 -56 -17
-108 -18 -740 -18 l-680 0 -3 548 -2 547 672 0 c565 0 683 -3 737 -15z"/>
</g>
</svg>
  );
};

export default BoldIcon;
